// removed by extract-text-webpack-plugin
module.exports = {"NewServiceAccount":"NewServiceAccount--18drg"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/ServiceAccount/NewServiceAccount.scss
// module id = 954
// module chunks = 1